import React from 'react';
import { Footer } from '../common';
import HomeNavBar from '../HomePage/HomeNavBar';
import LeftSidebar from '../HomePage/LeftSidebar';
import { MOCK_REPORTS, REPORT_STATUS_COLORS } from '../../constants';
import { useNavbarUser } from '../../utils/navbarUser';
import './ReportHistoryPage.css';

/**
 * Report History page displaying user's submitted reports.
 *
 * Uses the shared app layout (nav + sidebar + content).
 *
 * @returns {JSX.Element}
 */
function ReportHistoryPage() {
  const user = useNavbarUser();

  return (
    <div className="report-history-page">
      <HomeNavBar
        spadesBalance={user.spades}
        notificationCount={user.notifications}
        userAvatar={user.avatar}
        userName={user.name}
        onSpadesClick={() => {}}
        onLogout={() => {}}
      />

      <LeftSidebar />

      <main className="report-history-page__main">
        <div className="report-history-page__content">
          <h1 className="report-history-page__title">Report History</h1>

          <p className="report-history-page__subtitle">
            Track the status of content you've reported. Our team reviews all reports within 24-48 hours.
          </p>

          <div className="report-history-page__table-container">
            <table className="report-history-page__table">
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Content</th>
                  <th>Reason</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {MOCK_REPORTS.map((report) => (
                  <tr key={report.id}>
                    <td className="report-history-page__account">{report.account}</td>
                    <td>
                      <span className={`report-history-page__content-badge report-history-page__content-badge--${report.content.toLowerCase()}`}>
                        {report.content}
                      </span>
                    </td>
                    <td>{report.reason}</td>
                    <td>
                      <span
                        className="report-history-page__status"
                        style={{ color: REPORT_STATUS_COLORS[report.status] }}
                      >
                        <span className="report-history-page__status-dot" style={{ backgroundColor: REPORT_STATUS_COLORS[report.status] }} />
                        {report.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="report-history-page__legend">
            <div className="report-history-page__legend-item">
              <span className="report-history-page__legend-dot" style={{ backgroundColor: REPORT_STATUS_COLORS['In Progress'] }} />
              <span>In Progress — Under review</span>
            </div>
            <div className="report-history-page__legend-item">
              <span className="report-history-page__legend-dot" style={{ backgroundColor: REPORT_STATUS_COLORS['Deemed Compliant'] }} />
              <span>Deemed Compliant — No violation found</span>
            </div>
            <div className="report-history-page__legend-item">
              <span className="report-history-page__legend-dot" style={{ backgroundColor: REPORT_STATUS_COLORS['Deemed Non-Compliant'] }} />
              <span>Deemed Non-Compliant — Action taken</span>
            </div>
          </div>
        </div>

        <Footer />
      </main>
    </div>
  );
}

export default ReportHistoryPage;
